<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <!-- 系统补丁升级 -->
            <el-tab-pane>
                <span slot="label">{{ $t("logs.customize1") }} </span>
                <div class="lie">
                    <table>
                        <tbody  v-show="xian1">
                            <tr>
                                <td>{{ $t("logs.customize4") }}:</td>
                                <td style="height:44px;display:flex;align-items:center;justify-content: center;">
                                    <input type="file" @change="inputFileChange" id="iupfile" ref="clearFile" accept=".zip" />

                                </td>
                            </tr>

                             <tr>
                    <td>{{ $t("logs.customize2") }}:</td>
                    <td
                      style="flex-direction:row;padding-right:20px;align-items:center"
                    >
                      <el-input
                        v-model="index_cust"
                        placeholder
                        clearable
                      ></el-input>

                      <el-alert
                        :title="this.add_show_hint1"
                        type="warning"
                        show-icon
                        :closable="false"
                        style="width:auto"
                      ></el-alert>
                    </td>
                  </tr>
                   <tr>
                    <td>{{ $t("logs.customize3") }}:</td>
                    <td
                      style="flex-direction:row;padding-right:20px;align-items:center"
                    >
                      <el-input
                        v-model="logout_cust"
                        placeholder
                        clearable
                      ></el-input>

                      <el-alert
                        :title="this.add_show_hint2"
                        type="warning"
                        show-icon
                        :closable="false"
                        style="width:auto"
                      ></el-alert>
                    </td>
                  </tr>
                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                   
<el-button type="primary" @click="save_undown">{{
                        $t("logs.save_a")
                      }}</el-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table v-show="xian2">
                        <tbody>

                            <tr>
                                <td>{{this.upgrade_patch}}</td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="save_undown_two()">{{this.upgrade_patch}}</el-button>
                                    <el-alert :title="this.upgrade_patch_hint" type="warning" show-icon :closable="false"></el-alert>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
logout_cust:'',
index_cust:'',
add_show_hint2:'',
add_show_hint1:'',
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44"
            }],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS"
                },
                {
                    value: "选项2",
                    label: "增加信头标记"
                },
                {
                    value: "选项3",
                    label: "强制TLS"
                }
            ],
            checked: "",
            fileList: [] || '',
            radio: [],
            files: '',
            upgrade_patch: '',
            upgrade_patch_hint: '',
            upload_patch: '',
            upload_patch_hint: '',
            loading: false,
            xian1: true,
            xian2: false,

        };
    },
    mounted() {
        this.upload_patch_add()
    },
    computed: {
        // myHeader() {
        //     return {
        //         "authToken": window.sessionStorage.getItem('authToken')
        //     }
        // },
        myData() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            return {
                "__mode": 'upload_patch',
                "sid": sid,
            }
        }
    },

    methods: {
        upload_patch_add() {

            this.loading = true

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            let str = this.$qs.stringify({
                __mode: "show_upload",
                sid: sid,

            });
            // console.log(str)
            this.$axios
                .post("/api/adm/cgi/fmupgrade.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.upgrade_patch = res.data.ret.upgrade_patch
                        this.upgrade_patch_hint = res.data.ret.upgrade_patch_hint
                        this.upload_patch = res.data.ret.upload_patch
                        this.upload_patch_hint = res.data.ret.upload_patch_hint

                    }
                });

        },
        fileChange(file, fileList) {
            // console.log(file.raw)
            // console.log(fileList)
            this.fileList = fileList
            // if (fileList.legnth <= 0) {
            //     alert(1)
            // }
            // this.dataList = fileList
        },

        UploadUrl: function () {
            return "/api/adm/cgi/fmupgrade.cgi";
        },
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        // tanSend: function () {
        //     this.tanchu = false;
        //     // console.log(this.fileList)
        //     // this.fileChange()
        //     // if (this.fileList.length < 1) {
        //     //     alert('请选择文件')
        //     //     // return false
        //     // }
        //     // this.$refs.upload.submit();

        // },
        inputFileChange(e) {

            this.files = e.target.files[0];
            // console.log(this.files);
        },
        // 白名单增加
        save_undown_two() {

            // console.log(sid);
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/fmupgrade.cgi", {
                    params: {
                        __mode: "upgrade_patch",
                        sid: sid,

                    },
                })
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList3();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList3();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss1')}`,
                        });
                        this.xian1 = true
                        this.xian2 = false
                        // 

                    }
                })

        },
        // 白名单增加
        save_undown() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let iupfile = this.files;
            // console.log(iupfile);
            // 判断是否有文件
            if (0 == this.files.length) {
                this.$message({
                    type: 'info',
                    message: '请选择要上传的文件'
                });
                return;
            } else {
                this.tanchu = false;
                let fd = new FormData();
                fd.append("iupfile", iupfile);
                // for (var i = 0; i < this.files.length; i++) {
                //     fd.append('fileUpload', this.files[i]);
                // }
                fd.append("__mode", "upload_patch");
                fd.append("sid", sid);
                // console.log(fd);
                this.$axios({
                    method: "post",
                    url: "/api/adm/cgi/fmupgrade.cgi",
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: fd,
                }).then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                        // this.getFileList2();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;

                        // this.getFileList2();
                        this.$refs.clearFile.value = ''; // 清空file文件
                        this.files = ''
                        console.log(this.files)
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.del3')}`,
                        });
                        this.xian1 = false
                        this.xian2 = true
                    }
                    // this.getFileList2();
                });
            }
        },
        // 默认规则列表加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/fmupgrade.cgi", {
                    params: {
                        __mode: "upload_patch",
                        sid: sid,

                    },
                })
                .then((res) => {
                    // console.log(res);

                   if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList3();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                        // this.getFileList3();
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;

                        // 

                    }
                })
               
        },
        tanOff: function () {
            this.tanchu = false;
        }
    }
};
</script>

<style lang="less" scoped>
//  /deep/ .el-select .el-input__inner {
//     margin-left: -30px;
// }

.el-button {
    padding: 6px;
}

// 弹出框1

.el-input {
    // width: 20%;
    padding: 5px 10px 5px 0;
}

/deep/ .el-select {
    // padding-left: 30px;
    width: 222px;
}

// button  按钮
/deep/ .el-button {
    padding: 6px 10px;
    margin-left: 10px;
    margin: 5px 20px;
}

// input 框高度
/deep/ .el-input__inner {
    height: 30px;
}

.el-checkbox-group {
    display: flex;
}

.table span {
    font-size: 14px;
}

// th  改高度
/deep/ .el-table th {
    padding: 4px 0;
}

// td  改高度
/deep/ .el-table td {
    padding: 4px 0;
}

/deep/ .cell {
    text-align: center;
}

// 时间
.time {
    display: flex;
    flex-direction: column;
    border: 1px solid #dcdfe6;
    background: #f1f1f1;
    margin: 10px 0;
}

.time1 {
    display: flex;
    align-items: center;
    padding: 2px 0 2px 14px;
    font-size: 14px;
}

// 手动设置
.time-text1 {
    padding-left: 20px;
}

// 后台管理控制
.back {
    display: flex;
    font-size: 14px;
    line-height: 30px;
    align-items: center;
    padding: 6px 0;
}

// .back div {
//   margin: 0 10px;
// }

// /deep/ .el-tabs__nav-scroll {
//     display: flex;
//     padding-left: 0px;
//     justify-content: space-between;
// }

// background: #424F63;

// /deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
//     padding-left: 20px;
//     border-left: 0px;
// }

// /deep/ .el-tabs--top .el-tabs__item.is-top:last-child {
//     padding-right: 20px;
// }

// /deep/ .el-tabs__item.is-active {
//     //   color: #409eff;
//     background: #fff;
// }

// /deep/ .el-tabs__active-bar {
//     height: 0;
// }

// 弹框下的复选框
.el-checkbox:last-of-type {
    margin-right: 10px;
}

@import "../../css/table.less";

@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

/deep/ .el-tabs__nav {
    padding-left: 16px;
}
</style>
